module.exports = __webpack_public_path__ + "static/media/icon-plus--yellow.cd666fbb.svg";